import createIcon from '../../createIcon';

/**
 * @component @name ViewCozy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk0xMS4yNSAxNi43NUg3LjI1VjEyLjc1SDExLjI1VjE2Ljc1Wk0xMS4yNSAxMS4yNUg3LjI1VjcuMjVIMTEuMjVWMTEuMjVaTTE2Ljc1IDE2Ljc1SDEyLjc1VjEyLjc1SDE2Ljc1VjE2Ljc1Wk0xNi43NSAxMS4yNUgxMi43NVY3LjI1SDE2Ljc1VjExLjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewCozy = createIcon('ViewCozy', [
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM11.25 16.75H7.25V12.75H11.25V16.75ZM11.25 11.25H7.25V7.25H11.25V11.25ZM16.75 16.75H12.75V12.75H16.75V16.75ZM16.75 11.25H12.75V7.25H16.75V11.25Z',
      key: 'akme75',
    },
  ],
]);

export default ViewCozy;
